import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { CollectionNodeFieldComponent } from './collection-node-field.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
  ],
  declarations: [
    CollectionNodeFieldComponent,
  ],
  exports: [
    CollectionNodeFieldComponent,
  ],
})
export class CollectionNodesExportModule {}
